const companyTypes = ['LOAD_COMPANIES', 'SELECT_COMPANY'];

export default companyTypes;
